<template>
    <div>
        <Mainlayout></Mainlayout>
    <div>
      <CRow class="ml-5 mr-5 mb-5">
          <br /><br /><br />
        </CRow>
        <CContainer>
          <div class="text-center d-sm-down-none">
            <h3 class="custom-64px text-center">PRIVACY POLICY</h3>
            <div class="mt-5">
              <CButton
                color="info"
                class="custom-btn-login-forgot"
                @click="ShowTerm()"
                :style="
                  isShowTerm
                    ? 'color: #fff;background: #928AFD;font-family: Montserrat;font-style: normal;font-weight: 600;'
                    : 'background:#fff;border: 1px solid white;color:#171717;font-family: Montserrat;font-style: normal;font-weight: 600;'
                "
              >
              Terms of Use& Privacy Policy</CButton
              >
  
              <CButton
                color="info"
                class="custom-btn-login-forgot ml-2"
                @click="ShowNotice()"
                :style="
                  isShowNotice
                    ? 'color: #fff;background: #928AFD;font-family: Montserrat;font-style: normal;font-weight: 600;'
                    : 'background:#fff;border: 1px solid white;color:#171717;font-family: Montserrat;font-style: normal;font-weight: 600;'
                "
              >
              Personal Data Protection Notice</CButton
              >
  
  
              <CButton
                color="info"
                class="custom-btn-login-forgot ml-2"
                @click="ShowReturn()"
                :style="
                  isShowReturn
                    ? 'color: #fff;background: #928AFD;font-family: Montserrat;font-style: normal;font-weight: 600;'
                    : 'background:#fff;border: 1px solid white;color:#171717;font-family: Montserrat;font-style: normal;font-weight: 600;'
                "
              >
              Cancellation and Refund Policy</CButton
              >
            </div>
          </div>
  
          <div class="text-center d-md-none">
            <h3 class="custom-32px text-white text-center">TERMS AND CONDITION</h3>
            <div class="mt-5">
              <CButton
                color="info"
                class="custom-btn-login-forgot"
                @click="ShowTerm()"
                :style="
                  isShowTerm
                    ? 'color: #007cef;background: #ffffff;font-family: Montserrat;font-style: normal;font-weight: 600;'
                    : 'background:none;border: 1px solid white;color:#fff;font-family: Montserrat;font-style: normal;font-weight: 600;'
                "
              >
              Terms of Use& Privacy Policy</CButton
              >
              <br /><br />
              <CButton
                color="info"
                class="custom-btn-login-forgot"
                @click="ShowNotice()"
                :style="
                  isShowNotice
                    ? 'color: #007cef;background: #ffffff;font-family: Montserrat;font-style: normal;font-weight: 600;'
                    : 'background:none;border: 1px solid white;color:#fff;font-family: Montserrat;font-style: normal;font-weight: 600;'
                "
              >
              Personal Data Protection Notice</CButton
              >
  
              <br /><br />
              <CButton
                color="info"
                class="custom-btn-login-forgot"
                @click="ShowReturn()"
                :style="
                  isShowReturn
                    ? 'color: #007cef;background: #ffffff;font-family: Montserrat;font-style: normal;font-weight: 600;'
                    : 'background:none;border: 1px solid white;color:#fff;font-family: Montserrat;font-style: normal;font-weight: 600;'
                "
              >
              Cancellation and Refund Policy</CButton
              >
              
            </div>
          </div>
        </CContainer>
  
        <CRow v-if="TermInfo === true">
          <div class="card-custom-web">
            <CContainer class="p-3 mt-5">
            <br /><br />
                The following terms and conditions govern your access and use of
                this website Interviewrr.com and all information, content, products,
                services and functionality available at or through the site
                (“Website”). This Website is owned and operated by Interviewrr
                (Company No: 1312076-K), a company incorporated under the laws of
                Malaysia with its business address (“the Company”, “we”, “us”,
                and/or “our”).
                <br /><br />
                The Company website uses cookies to enable us to retrieve user
                details for each visits to enable some functionality of some area
                for the ease of use for the visiting user.
  
                <br /><br />
                <h5>AGREEMENT</h5>
                <br /><br />
                The Terms of Use (“Agreement” or “Terms”) and the Privacy Policy
                posted on this Website (which are incorporated into this Agreement
                by reference), as revised from time to time, sets forth the
                legally binding terms for your use of this Website. By visiting,
                accessing or using this Website, you are accepting this Agreement
                and you represent and warrant that you have the right, authority,
                and capacity to enter into this Agreement (on behalf of yourself
                or the entity that you represent). Unless otherwise limited or
                restricted by the law of territory of which you reside in, or use
                this Website from, the use of this Website is open for anyone,
                either those residing or using this Website in Malaysia or outside
                of Malaysia. Notwithstanding the foregoing, you hereby understood
                and agreed that you are at a majority age whichever is applicable
                under the law of territory of which you reside in, for you to
                access or use this Website or accept this Agreement. You further
                agree that if you do not agree with any part or all of the
                provisions of this Agreement, you shall not, or continue to,
                access and/or use this Website.
                <br /><br />
  
                Your access to and use of this Website is conditioned on your
                acceptance of and compliance with these Terms. By accessing or
                using this Website, you agree to be bound by these Terms. This
                Website that the Company provides is always evolving and the form
                and nature of this Website may change from time to time without
                prior notice to you. In addition, the Company may stop
                (permanently or temporarily) providing access to this Website (or
                any features within this Website) to you or in general and may not
                be able to provide you with any prior notice. We also retain the
                right to create limits on use and storage at our sole discretion
                at any time without prior notice to you.
  
                <br /><br />
                 <h5>YOUR ACCOUNT</h5>
                 <br /><br />
                 <h5>A) CREATION OF ACCOUNT</h5>
                  <br /><br />
                  In order to use the Service, you are required to register an account with us. We
  will perform/process to validate the identity before approving your application.
  We have the absolute discretion to accept and/or reject your application. Our
  decision is conclusive and binding on you and you have no right to question our
  decision.
  
   <br /><br />
   <h5>B) ACCURACY OF YOUR INFORMATION</h5>
   <br /><br />
   You must provide us with accurate and complete information and keep that
  information accurate, complete and up-to-date. We may but have no obligation,
  whether express or implied, to verify the accuracy and authenticity of any
  information provided by you. Please take note that we have the right to
  suspend, and/or forthwith terminate your use of the Service if the information
  provided by you is untrue, inaccurate, not current or incomplete, or we suspect
  that such information provided by you is untrue, inaccurate, not current or
  incomplete.
  
  <br /><br />
   <h5> SECURITY</h5>
   You play an important role in safeguarding any Transaction made through your
  mobile device. We recommend you take the following steps. These steps are
  not exhaustive: -
  <ul>
    <li>enable password on your mobile device;</li>
     <li>avoid using public WIFI networks;</li>
      <li>install applications from sources you trust;</li>
       <li>keep your login credential secure and confidential;</li>
        <li>create a unique password for Account; and</li>
         <li>monitor your Account activity</li>
  </ul>
  <br /><br />
  
  <h5> D) CREDIT HOUR</h5>
  <br /><br />
  Any Transaction and/or communication sent from your mobile app shall be
  deemed to have been transacted and/or sent by you irrespective of whether
  such transaction and/or communications were actually sent by you or not. You
  shall be personally liable and responsible for the use of your mobile app
  including but not limited to all transactions undertaken and/or transacted using
  the mobile app once the said transaction has been authenticated irrespective
  of whether the transactions is undertaken and/or transacted by you unless it
  can be established that such transaction and/or communication was 
  erroneously transacted due to our error. You should frequently review your
  mobile app to check and verify your Credit Hour Balance to ensure is enough to
  cover your tuition fees. You must always ensure that there are sufficient funds
  in your app before the tuition class started. 
  
  <h5>E) EPAY</h5>
  <br /><br />
  ePay payment can only be in Ringgit Malaysia or any approved currency registered within the App and once the Account is activated
  , have performed a ePay payment, the tuition online services can be
  started within the scheduled timetable provided in the Service. The status of
  your credit hour will be updated after the online class has been conducted. We
  reserve the right to suspend, revoke and/or block any payment to your mobile
  app account if we discover or have been informed by any third parties including
  the Appropriate Authority to be irregular, suspicious, illegal or unauthorized.
  
  <br /><br />
  <h5>F) DORMANT ACCOUNT</h5>
  <br /><br />
  We will terminate your Account if your Account has been dormant for a
  minimum of three (3) years with no remaining Credit Hour.
  
                <h5>RESTRICTION ON USAGE</h5>
                <br /><br />
                You shall use this Website/App in accordance with the terms of this
                Agreement, and shall not: (a) decompile, reverse engineer,
                disassemble, attempt to derive the source code of, or decrypt this
                Website/App; (b) make any modifications, adaptation, improvement,
                enhancement, translation, or derivative work from this Website/App;
                (c) violate any applicable laws, rules, or regulations in
                connection with your access or use of this Website/App; (d) remove,
                alter, or obscure any proprietary notice (including any notice of
                copyright or trademark) of the Company or its affiliates,
                partners, suppliers or the licensors of this Website/App; (e) use this
                Website/App for any revenue generating endeavour, commercial
                enterprise, or other purpose for which it is not designed or
                intended; (f) use this Website/App for creating a product, service, or
                software that is directly, or indirectly, competitive with or in
                any way a substitute for any contents, product, or software
                offered by the Company; (g) use this Website/App to send automated
                queries to any website/App or device or to send any unsolicited
                commercial e-mail; or (h) use any proprietary information or
                interfaces of the Company or other intellectual property of the
                Company in the design, development, manufacture, licensing, or
                distribution of any this applications, accessories or devices for
                use with this Website/App.
  
                <br /><br />
                <h5>USER CONTENT</h5>
                <br /><br />
                “User Content” means any and all information and content that you,
                or a User submits to, or uses with regards to, this Website/App,
                including but not limited to, content in the User’s Feedback and
                Correspondence (as defined below).
  
                <br /><br />
                You are solely responsible for your User Content and you assume
                all risks associated with the use of your User Content, including
                any reliance on its accuracy, completeness or usefulness by
                others, or any disclosure of your User Content that makes you or
                any third party personally identifiable. You hereby represent and
                warrant that your User Content does not violate the acceptable of
                Usage of Website/App (as defined below). You shall not state or imply
                that your User Content is in any way provided, sponsored or
                endorsed by the Company. You further acknowledge and agree that
                you alone, are accountable and responsible for your User Content,
                and you may expose yourself to liability under this Terms or laws
                and regulations governing your use of this Website/App. The Company is
                not responsible or obligated to backup any User Content and User
                Content may be deleted at any time. You hereby acknowledge and
                agree that you are solely responsible for creating backup copies
                of your User Content if you so desire.
  
                <br /><br />
  
                Each User is solely responsible for any and all of its User
                Content and because we do not control User Content, you
                acknowledge and agree that we are not responsible for any User
                Content and we make no guarantees regarding the accuracy,
                currency, suitability, or quality of any User Content, and we
                assume no responsibility for any User Content.
  
                <br /><br />
                If you provide us any feedback, reviews and recommendation or
                suggestions regarding this Website/App (“Feedback and
                Correspondence”), you hereby agree that we will have the right to
                use or share such Feedback and Correspondence and related
                information in any manner it deems this appropriate. We shall
                treat any Feedback and Correspondence you provide to us as
                non-confidential and non-proprietary. You agree that you will not
                submit to us any information or ideas that you consider to be
                confidential or proprietary.
  
                <br /><br />
                <h5>USAGE OF WEBSITEM</h5>
                <br /><br />
                The acceptable “Usage of Website” are as below :
                <br /><br />
                <li>
                  you agree not to use this Website/App to collect, upload, transmit,
                  display, or distribute any User Content (i) that violates any
                  third-party right, including any intellectual property rights,
                  trade secret, moral right, privacy right, right of publicity, or
                  any other proprietary right; (ii) that is unlawful, harassing,
                  abusive, tortious, threatening, harmful, invasive of another’s
                  privacy, vulgar, defamatory, false, intentionally misleading,
                  trade libellous, pornographic, obscene, patently offensive,
                  promotes racism, bigotry, hatred, or physical harm of any kind
                  against any group or individual or is otherwise objectionable;
                  (iii) that is harmful to minors in any way; or (iv) that is in
                  violation of any law, regulation, or obligations or restrictions
                  imposed by any third party.
                </li>
                <li>
                  In addition, you agree not to use this Website/App to: (i) upload,
                  transmit, or distribute any computer viruses, worms, or any
                  software intended to damage or alter a computer system or data;
                  (ii) send unsolicited or unauthorized advertising, promotional
                  materials, junk mail, spam, chain letters, pyramid schemes, or
                  any other form of duplicative or unsolicited messages, whether
                  commercial or otherwise; (iii) harvest, collect, gather or
                  assemble information or data regarding other Users, including
                  e-mail addresses, without their consent; (iv) interfere with,
                  disrupt, or create an undue burden on servers or networks
                  connected to this Website/App or violate the regulations, policies
                  or procedures of such networks; (v) attempt to gain unauthorized
                  access to this Website/App, other computer systems or networks
                  connected to or used together with this Website/App, through
                  password mining or other means; (vi) harass or interfere with
                  another User’s use and enjoyment of this Website/App; or (vii)
                  introduce software or automated agents or scripts to this
                  Website/App so as to produce multiple accounts, generate automated
                  searches, requests and queries, or to strip, scrape, or mine
                  data from this Website/App (except that we grant the operators of
                  public search engines revocable permission to use spiders to
                  copy materials from the Site for the sole purpose of and solely
                  to the extent necessary for creating publicly available
                  searchable indices of the materials, but not caches or archives
                  of such materials).
                </li>
  
                <br /><br />
                <h5>INTELLECTUAL PROPERTY AND LICENSE</h5>
                <br /><br />
                <h5>Ownership</h5>
                <br /><br />
                Excluding your User Content, you acknowledge and agree that all
                the intellectual property rights, including copyrights, patents,
                trademarks, and trade secrets, in this Website/App is, unless
                otherwise expressly stated or prohibited, owned by us or our
                licensors, or otherwise assigned or licensed to us. The provision
                of this Website/App does not transfer to you or any third party, any
                rights, title or interest in or to such intellectual property
                rights. The Company reserve all rights not granted in this
                Agreement or rescinded the rights make available for use in this
                Website/App. The proprietary software associated with this Website/App,
                including any enhancements or modifications thereto and any
                related documentation, as well as the visual and textual elements
                and the selection, arrangement and compilation of data embodied in
                (and/or displayed during the execution of) the software, are
                copyrighted works and exclusively owned by us or our licensors. In
                addition, this Website/App, including all software, any contents,
                inventions, technology, products, contents and data provided to,
                on or through this Website/App, are, unless otherwise expressly stated
                or prohibited, owned by us or our licensors, or otherwise assigned
                or licensed to us by you, and are protected under the relevant
                copyright, patent, trademark and/or other intellectual property
                laws and thereafter incorporated as a valuable information of the
                Company, and are the exclusive property of the Company.
  
                <br /><br />
                <h5>License</h5>
                <br /><br />
                Subject to the terms of this Agreement, the Company grants you a
                limited, personal, revocable, non-sub-licensable,
                non-transferable, non-exclusive, license to use this Website/App for
                your personal, non-commercial use. Subject to the aforesaid
                provision above, this Agreement does not transfer from the Company
                to you, any the Company or third party, intellectual property
                rights, and any rights, titles and interest in, to and under such
                property will remain solely with the Company or such third party,
                as the case may be. The Company, this Website/App, the Company logo,
                and all other copyrights, trademarks, service marks, graphics and
                logos used or displayed in connection with this Website/App, any
                advertisements or Third-Party Site, are copyrights, trademarks or
                registered trademarks of the Company or any relevant third
                parties. Your use of this Website/App does not grant you any right or
                license to reproduce or otherwise use any the Company or
                third-party intellectual property rights.
  
                <br /><br />
                <h5>License for User Content</h5>
                <br /><br />
  
                You hereby grant, and you represent and warrant that you have the
                right to grant, to the Company an irrevocable, non-exclusive,
                royalty-free and fully paid, worldwide sub-licensable licence to
                reproduce, distribute, publicly display and perform, prepare
                derivative works of, incorporate into other works, and otherwise
                use your User Content, and to grant sublicenses of the foregoing,
                for the purposes of including your User Content in this Website/App
                and to use the User Content for any purposes. You hereby
                acknowledge and agree to irrevocably waive (and cause to be
                waived) any claims and assertions of moral rights or attribution
                with respect to your User Content.
  
                <br /><br />
  
                You agree that you shall NOT post or share any Feedback and
                Correspondence that (i) impersonates another person or entity in a
                manner that does or is intended to mislead, confuse, or deceive
                others; (ii) violates the rights of a third party, including
                copyright, trademark, privacy, and publicity rights; (iii)
                promotes discrimination, hatred or harm against any individual or
                group; (iv) is a direct and specific threat of violence to others;
                (v) is defamatory, obscene or pornographic; (vi) is furtherance to
                illegal activities; or (vii) is harassing, abusive, or constitutes
                spam.
  
                <br /><br />
                <h5>ENFORCEMENT</h5>
                <br /><br />
                We reserve the right, without undertaking any liabilities or
                obligations to indemnify you or any third party, to review any
                User Content, investigate, and/or take this applicable action
                against you in our sole discretion if you violate the law, the
                Acceptable Use Policy or any other provision of this Agreement or
                otherwise create liability for us or any other person. Such acts
                may include removing or modifying your User Content, restricting
                your access to this Website/App and/or reporting you to law
                enforcement authorities.
  
                <br /><br />
                <h5>ADVERTISEMENT</h5>
                <br /><br />
                This Website/App may include advertisements, which may be targeted to
                the content or information on this Website/App, queries made through
                this Website/App, or other information. The types and extent of
                advertising by the Company on this Website/App is subject to change.
                In consideration for the Company granting you access to and use of
                this Website/App, you hereby acknowledge and agree that the Company,
                any of its third-party providers and partners may place or send
                you any form of advertisement (as defined below), on this Website/App
                or in connection with, or based on the display of content by you,
                or information from this Website/App whether submitted by you.
  
                <br /><br />
                <h5>THIRD PARTY SITES</h5>
                <br /><br />
                The Website/App may contain links to third party websites and
                contents. Third Party Sites (which include but not limited to
                advertisements) are not under our control and we are not
                responsible for any advertisements, Third-Party Sites or any
                products or contents promoted in or on such advertisements and
                Third-Party Sites. This Website/App provides these advertisements and
                access to Third Party Sites only as a convenience and does not
                warrant or make any representations with respect to the
                advertisements and Third-Party Sites. Your use all the
                advertisements and Third-Party Sites, and the products and
                contents promoted in or on the advertisements and Third-Party
                Sites at your own risk. When you access a link to a Third-Party
                Site, you acknowledge and agree that you may be subjected to a
                separate terms and policies, or the applicable third party’s terms
                and policies and you acknowledge and agree that you may be
                required to abide by those terms, including the third party’s
                privacy practices and acceptable use policies. You acknowledge and
                agree that you are responsible to make any investigation you feel
                necessary or this appropriate before proceeding with any
                transaction in connection with such advertisements and Third-Party
                Sites and your interactions with the advertisers and any third
                parties in respect of the advertisements and Third-Party Sites
                within or outside this Website/App is solely between you and such
                advertisers and third parties. You hereby acknowledge and agree
                that the Company will not be responsible for any direct and
                indirect loss or damage incurred as the result of such
                interactions. You further acknowledge and agree that if there is
                any dispute between you and such advertisers and third parties, we
                are under no obligation to assist, mediate or otherwise
                responsible for such dispute and resolutions related thereto. In
                addition, we hereby reserve the right to restrict access to any
                advertisements and Third Party Sites, including the right to limit
                the number and type of advertisements that are delivered to you
                through this Website/App without providing any reason.
  
                <br /><br />
                <h5>DISCLAIMERS</h5>
                <br /><br />
                You acknowledge and agree that use of Website/App is entirely at your
                own risk. Website/App are provided ‘as-is’ and ‘as available’ and we
                (and our shareholders, licensors, suppliers and agents) expressly
                disclaim any warranties and conditions of any kind including
                endorsements and undertakings, whether express or implied, in
                connection with Website/App and/or your use thereof, including the
                warranties or conditions of merchantability, fitness for a
                particular purpose, title, quiet enjoyment, accuracy or
                completeness of Website/App and/or the Company’s content or the
                content of any products or contents displayed, linked to, or
                integrated with Website/App (including, without limitation, any
                advertisements and third party sites’ content), or non-
                infringement of intellectual property rights. We (and our
                licensors, suppliers and any third party) make no warranty that
                Website/App (a) will meet your requirements, (b) will be available on
                an uninterrupted, timely, secure, or error-free basis and without
                omissions, or (c) will be accurate, reliable, or secure. We
                further disclaim that Website/App will be free of viruses, bugs,
                malware, adware, trojan horses or other harmful code which may be
                transmitted to or through Website/App by any third party, and we
                assume no liability or responsibility for personal injury or
                property damage, of any nature whatsoever, resulting from your
                access to and use of Website/App, any unauthorised access to or use of
                Website/App, your ads account or our servers, and/or any and all
                personal information stored therein, any interruption or cessation
                of transmission to or from Website/App, any loss or damage to content
                or data (whether stored through Website/App or otherwise), or any loss
                or damage of any kind incurred as a result of the use of any
                content posted, e-mailed, imported, transmitted, distributed, or
                otherwise made available via Website/App. The Company does not
                warrant, endorse, guarantee or assume responsibility for any
                products, contents or opportunity advertised or offered by an
                advertiser or third party through Website/App, or any hyperlinked or
                integrated Website/App or contents, and the Company will not be a
                party to or in any way be responsible for monitoring or enforcing
                any transaction between you and any third party (including any
                point of sale contents, advertisers or other third party which
                offers or attempts to take advantage of a deal or promotion
                through Website/App). No opinion, advice, or statement of the Company,
                whether made on this Website/App or otherwise, will create any
                warranty not expressly stated in this agreement. You acknowledge
                and agree that you will be solely responsible for, and hereby
                waive, any and all claims and causes of action with respect to any
                damage to your device, or any other piece of hardware, software,
                equipment, or device installed on or used for this Website/App, and in
                connection with your device or any other device, software,
                computer system, internet access, or loss of data that results
                from downloading or otherwise obtaining information through the
                use of Website/App.
  
                <br /><br />
                <h5>LIABILITY</h5>
                <br /><br />
                In no event will we (and our shareholders, licensors, suppliers
                and agents) be liable to you or any third party for loss or
                damages of any kind, including without limitation, any direct,
                indirect, consequential, exemplary, incidental, consequential,
                economic, special, exemplary or punitive damages regardless of the
                nature of the action, arising directly or indirectly, from or
                relating to this agreement or your use of, or inability to use
                Website/App, even if we have been advised of the possibility of such
                damages. Your sole and exclusive remedy against us is to
                discontinue your use of Website/App by closing your ads account. These
                limitations shall website-ly to the fullest extent permitted by
                law. By registering a ads account or downloading, installing,
                accessing, or using Website/App, you understand that you are waiving
                rights with respect to claims that are at this time unknown or
                unsuspected, and in accordance with such waiver, you hereby agree
                to release and forever discharge us, and our directors,
                shareholders, officers, employees, representatives, agents, and
                suppliers, and its and their respective successors and assigns,
                and all other related persons or entities, from any and all manner
                of rights, claims, complaints, suits, demands, causes of action,
                proceedings, liabilities, obligations, legal fees, costs, and
                disbursements of any nature whatsoever, whether known or unknown,
                which now or hereafter arise from, relate to, or are connected
                with your use of Website/App.
  
                <br /><br />
                <h5>INDEMNITY</h5>
                <br /><br />
                You agree to indemnify and hold us (and our shareholders,
                officers, employees, suppliers, licensors and agents) harmless,
                including costs and attorneys’ fees (on a solicitor-client basis),
                from and against any and all claims, actions, lawsuits, damages,
                obligations, complaints, demands, allegations, losses,
                liabilities, costs or debt, and expenses (including, but not
                limited to, legal fees on a solicitor-client basis) made by any
                third party due to or arising out of or in connection with, actual
                or alleged, (a) your use of this Website/App, (b) your User Content,
                (c) your violation of this Agreement, (d) your violation of any
                third party right including, intellectual property rights, trade
                secret, publicity or privacy rights, or (e) your violation of this
                applicable laws or regulations. We reserve the right, at your
                expense, to assume the exclusive defence and control of any matter
                for which you are required to indemnify us, and you agree to
                cooperate with our defence of these claims. You agree not to
                settle any matter without our prior written consent. We will use
                reasonable efforts to notify you of any such claim, action or
                proceeding upon becoming aware of it.
  
                <br /><br />
                <h5>WAIVER</h5>
                <br /><br />
                You hereby waive and relinquish, each and every past, present and
                future dispute, claim, controversy, demand, right, obligation,
                liability, action and cause of action of every kind and nature
                (including personal injuries, death, and property damage), that
                has arisen or arises directly or indirectly out of, or relates
                directly or indirectly to, your use of this Website/App and any
                interactions with, or act or omission of, the Company.
  
                <br /><br />
                <h5>TERM AND TERMINATION</h5>
                <br /><br />
                Subject to the terms herein, this Agreement will remain in full
                force and effect while you use this Website/App. We may (a) suspend
                your rights to use this Website/App or (b) vary or terminate this
                Website/App and/or terminate this Agreement, at any time for any
                reason at our sole discretion, including for any use of this
                Website/App in violation of this Agreement without prior notification.
                Upon termination of this agreement, your right to access and use
                this Website/App will be terminated immediately.
                <br /><br />
  
                We will not have any liability whatsoever to you for any variation
                or termination of this Agreement and/or this Website/App, including
                for deletion of your User Content. Upon termination of this
                Agreement, the provisions of this Agreement which deals with
                termination and post-termination terms, rights and obligations
                shall survive and remain in effect (including terms by their very
                nature is meant to survive and remain in effect).
  
                <br /><br />
                <h5>MODIFICATION</h5>
                <br /><br />
                We reserve the right, at any time, to vary, modify, suspend, or
                discontinue this Website/App or any part thereof without notice. You
                hereby acknowledge and agree that the Company will not be liable
                to you or to any third party for any modification, suspension, or
                discontinuance of contents or any part thereof.
  
                <br /><br />
                <h5>UPDATES AND CHANGES</h5>
                <br /><br />
  
                From time to time, this Website/App may automatically download and
                install, or may prompt you to download and install updates from
                the Company. These updates are designed to improve, enhance and
                further develop this Website/App in the form of bug fixes, enhanced
                functions, new software modules and/or completely new versions.
                You agree to receive such updates (and permit the Company to
                deliver these to you) as part of your continued use of this
                Website/App. You understand that your refusal to download and install
                updates may cause your access to this Website/App to be disabled. You
                acknowledge and agree that the form, features and/or nature of
                this Website/App which we provide may change from time to time without
                prior notice to you. We may also cease or discontinue providing
                this Website/App, or support or upgrades for this Website/App, at any
                time. Such new features and/or contents shall be subject to the
                Terms. We may also introduce new contents, modify or eliminate
                existing contents, modules or features of this Website/App and your
                sole and exclusive remedy, and our sole liability, in connection
                with any such change, modification or elimination is to terminate
                your account with us. Your continued use of or access to this
                Website/App following the posting or distribution of any changes to
                the Agreement constitutes acceptance of those changes.
  
                <br /><br />
                <h5>CHANGES OF TERMS OF USE</h5>
                <br /><br />
  
                We reserve the right, at our sole discretion, to vary, revise,
                amend or update any part of the Agreement by posting the amended
                or updated Agreement on this Website/App. These changes will be
                effective immediately, unless otherwise stipulated therein. While
                we may attempt to notify you when major changes are made to the
                Agreement, you hereby acknowledge and agree that it is your sole
                responsibility to check the Agreement periodically for any
                changes. Continued use of this Website/App following the posting or
                notice of such changes will indicate your acknowledgment of such
                changes and agreement to be bound by the terms and conditions of
                such changes.
  
                <br /><br />
                <h5>THIRD PARTY TERMS</h5>
                <br /><br />
  
                You agree that in addition to the Agreement, your use of the this
                Website/App is subject to the usage rules set forth in this any other
                third party platform, developer or distributor end user licensing
                agreements and/or terms and conditions by which you agree to be
                bound when you download this Website/App or otherwise access this
                Website/App.
  
                <br /><br />
                <h5>ENTIRE AGREEMENT</h5>
                <br /><br />
                This Agreement constitutes the entire agreement between you and us
                regarding the use of this Website/App. Our failure to exercise or
                enforce any right or provision of this Agreement will not operate
                as a waiver of such right or provision.
  
                <br /><br />
                <h5>HEADINGS AND TITLES</h5>
                <br /><br />
  
                The section titles of this Agreement are for convenience only and
                have no legal or contractual effect. The word including means
                including without limitation.
  
                <br /><br />
                <h5>SEVERABILITY</h5>
                <br /><br />
                If any provision of this Agreement is, for any reason, held to be
                invalid or unenforceable, the other provisions of this Agreement
                will be unimpaired and the invalid or the unenforceable provision
                will be deemed modified so that it is valid and enforceable to the
                maximum extent permitted by law.
  
                <br /><br />
                <h5>RELATIONSHIP</h5>
                <br /><br />
  
                Your relationship with us is that of an independent contractor,
                and neither party is an agent or partner of the other.
  
                <br /><br />
                <h5>ASSIGNMENT</h5>
                <br /><br />
                This Agreement, and your rights and obligations herein, may not be
                assigned, subcontracted, delegated, or otherwise transferred by
                you without the Company’s prior written consent, and any attempted
                assignment, subcontract, delegation, or transfer in violation of
                the foregoing will be null and void. The terms of this Agreement
                will be binding upon assignees. We may assign or novate this
                Agreement to another entity upon or without notification via this
                Website/App, upon which this Agreement shall be between you and such
                assigned or novated entity.
  
                <br /><br />
                <h5>SUCCESSORS BOUND</h5>
                <br /><br />
                No term of this Agreement is enforceable by a person who is not a
                party to this Agreement. This Agreement will be binding upon and
                will inure to the benefit of the parties, their successors and
                permitted assigns.
  
                <br /><br />
                <h5>GOVERNING LAW</h5>
                <br /><br />
  
                This Agreement is governed by the laws of Malaysia, without regard
                to the choice or conflicts of law provisions of any jurisdiction,
                and any disputes, actions, claims or causes of action arising out
                of or in connection with this Agreement or this Website/App shall be
                subject to the exclusive jurisdiction of the courts of Malaysia to
                which you hereby agree to submit to.
  
                <br /><br />
                <h5>ARBITRATION</h5>
                <br /><br />
                In the event that the law of territory of which you reside in, or
                use this Website/App from, does not allow jurisdiction to be that of
                the courts of Malaysia or where judgment of a Malaysian court is
                unenforceable in such territory, any disputes shall be exclusively
                resolved by arbitration under the rules of the Asian International
                Arbitration Centre (“AIAC”) in force as at the date of this
                application for arbitration (“AIAC Rules“) and the AIAC Rules are
                hereby incorporated by reference into this Agreement. The
                arbitration shall be conducted before a sole arbitrator this
                appointed by the Chairman of AIAC. The seat, or legal place of
                arbitration, shall be Kuala Lumpur, Malaysia and the language of
                the arbitration shall be English. All documents submitted in
                connection with the proceedings shall be in the English language,
                or, if in another language, accompanied by an English translation.
                The arbitration award rendered shall be in writing and shall set
                out the reasons for the arbitrator’s decision. The award shall
                apportion the costs of the arbitration as the arbitrator deems
                fair and each party hereby acknowledge and agree that the
                arbitration award shall be final and binding on both parties and
                may be enforced in any court of competent jurisdiction. Without
                prejudice to the above provisions, either party may seek
                injunctive relief, including restraining orders and preliminary
                injunctions, in any court of competent jurisdiction, and either
                party may request that a court refers the proceedings to
                arbitration in accordance with this Agreement.
          </CContainer>
              </div>
       
        </CRow>
  
        <CRow v-if="Notice === true">
          <div class="card-custom-web">
            <br /><br />
            <CContainer class="p-3 mt-5">
            We at Interviewrr (Company No.: 1312076-K), a private company
                limited by shares incorporated under the laws of Malaysia (the
                “Company”, “we”, “us” and/or “our”)) recognise the importance of
                privacy and the overall sensitivity of personal data and
                information. As required under the Personal Data Protection Act
                2010 (“the Act”), the purpose of this Personal Data Protection
                Notice (the “Notice”) is for the adherence of the regulations set
                forth under the Act and shall at all times act as the official
                notice of the Company in describing how the Company manages,
                safeguards, collects, gather, and process your personal data when
                you appoint and/or engage our services, use or access our Website/App
                and other digital platforms of the Company and/or interact with us
                in any capacity which includes through meetings, seminars,
                conferences, discussions and/or events.
  
                <br /><br />
  
                Henceforth, by submitting your own or another individual’s
                personal data, you confirm that you and such other individual
                agree to the Company’s collection, usages and disclosure of such
                data in accordance with this Notice. Please consider that at this
                time in this Notice, we have expressed and provide fair and
                reasonable notice to you that in the event you do not wish any
                such data to be used in any such way as prescribed in this Notice,
                do not submit to us and/or any of our representatives any such
                data, but doing otherwise you hereby consent and acknowledge the
                existence of this Notice and thus understand and agree to the
                contents of Notice.
  
                <br /><br />
  
                This Notice may be amended and/or updated from time to time
                without prior notice. By continuing to use or engage our services,
                usage of Website/App and/or to communicate with us subsequent to any
                amendments and updates to this Notice, it shall be construed and
                confirmed your acceptance to said amendments and updates.
  
                <br /><br />
                <h5>THE PERSONAL DATA COLLECTED</h5>
  
                <br /><br />
                Personal data generally means any such information and/or data
                that may be used to identify you which includes but not limited to
                identification details, contact details and any other information
                which may lead to your identification.
                <br /><br />
  
                The Company may from time to time collect personal data in the
                course of our services by which the data is provided by yourself
                and or your representatives and or by any individual on your
                behalf in which case, we will assume, until notified otherwise,
                that you have authorised the disclosure of such data to us.
  
                <br /><br />
  
                The Company may also, from time to time, collect personal data
                through the access of our Website/App and/or any digital platforms
                owned and operated by the company for the purpose of
                communications, subscriptions and enquiries with regard to our
                company and/or our services.
  
                <br /><br />
  
                Personal data collected will be mainly provided by you, however
                some personal data may also be collect by us from other available
                sources which includes but not limited to credit reporting
                agencies, government department or agencies, public registries,
                Website/App, social media, publications, events, seminars and
                conferences for the purpose rendering our services to you and
                compliance with legal and regulatory requirements under the laws
                of Malaysia.
  
                <br /><br />
  
                <h5>USAGE OF PERSONAL DATA</h5>
                <br /><br />
                Your personal data is collected and processed by us for our
                business activities which includes but not limited to the
                following purposes:
  
                <br /><br />
  
                1. to verify your identity; <br />
                2.to communicate with you including responding to your enquiries;
                <br />
                <li>
                  all purposes related to or in connection with our engagement;
                </li>
  
                <br /><br />
  
                1.to comply with legal and/or regulatory requirements including
                court orders;
                <br /><br />
  
                2.for our day-to-day operations and administrative purposes
                including file management, billing and collection, audits,
                reporting, investigations etc.;
                <br /><br />
  
                3.for the purposes of enforcing or defending our legal rights
                and/or obtaining legal advice;
  
                <br /><br />
  
                <li>
                  to send you materials or publications including newsletter,
                  articles or updates or information about events, conferences,
                  seminars, talks which may be of interest to you;
                </li>
  
                <br /><br />
  
                1. to promote, offer or market our services to you; to send as
                potential referees that may assist the growth of your business;
  
                <br /><br />
                2. to assist in the prevention, detection or investigation of
                crime or possible criminal activities or for the administration of
                justice;
  
                <br /><br />
                3.for security and internal audit purposes; for such other
                purposes as may be directed or consented to by you; and for all
                other purposes in relation to or incidental to the above.
  
                <li>
                  for such other purposes as may be directed or consented to by
                  you; and
                </li>
                <li>
                  for all other purposes in relation to or incidental to the
                  above.
                </li>
  
                <br /><br />
  
                <h5>DISCLOSURE OF PERSONAL DATA</h5>
  
                Under certain circumstances, we may be required to disclose your
                personal data to third parties. Third parties to whom your
                personal data may be disclosed by us are as follows:
                <br /><br />
                1.any persons directed by or consented to by you;
                <br /><br />
                2.any persons required for the purposes of the legal engagements
                and/or legal transactions including but not limited to counter
                parties, other advisors, financial institutions, regulatory bodies
                etc;
                <br /><br />
                <li>
                  any person for the purposes of compliance with legal and
                  regulatory requirements;
                </li>
                1.our data processors i.e. third party who we engage to process
                personal data on our behalf including but not limited to archival
                storage, data entry service providers, computer backup services,
                disaster recovery services, banks and financial institutions etc.;
                and
                <br /><br />
                2.our professional advisors including but not limited to legal
                advisors, tax advisors, financial advisors, auditors, insurance
                brokers etc.
                <br /><br />
                Further, we may also be required to transfer your personal data
                outside of Malaysia for the purposes and to such third parties
                stated in this Notice. The transfer of your personal data outside
                Malaysia would also be required if you are travelling, residing or
                based outside Malaysia.
  
                <br /><br />
                <h5>DICLAIMER</h5>
                <br /><br />
                DISCLAIMER We acknowledge that you have the right in deciding the
                information you wish to provide to us. The provision of the
                information listed above is voluntary in nature. However, please
                note that if you do not provide the information above or limit the
                way such information is to be processed, it may result in us not
                being able to:
  
                <br /><br />
                1. communicate or correspond with you; <br />
                2.undertake the legal engagement or transaction and/or to provide
                our services to you; and/or
                <br /><br />
                If you request your data to be withdrawn and/or withhold from any
                usages, please submit to contact@Interviewrr.com
  
                <br />
                <br />
                Please note that the Company may imposed administrative chargers
                for any request as described above and that we reserve the right
                to refuse you request for any reasons permitted under the law of
                Malaysia. By not informing us in such way, we will assume that we
                have your implied consent to use your personal data as prescribed
                in this Notice.
              </CContainer>
          </div>
       
        </CRow>
  
  
        <CRow v-if="Return === true">
          <div class="card-custom-web">
            <br /><br />
            <CContainer class="p-3 mt-5">
              Our cancellation and refund policy for Interviewrr tuition classes is as follows: 
              <br /><br />
              If a student wishes to cancel their enrollment in a Interviewrr class, they must inform us in writing via email, letter or messenger (Whatsapp/Telegram). 
              <br /><br />
              If a student cancels their enrollment at least 14 days prior to the start of the class, they will receive a full refund of any fees paid.
              <br /><br />
              If a student cancels their enrollment less than 14 days prior to the start of the class, they will not be eligible for a refund. 
              <br /><br />
              If a student fails to attend the class, they will not be eligible for a refund. If a Interviewrr class is canceled by the teacher due to unforeseen circumstances (e.g. natural disasters, pandemics), all fees will be fully refunded. 
              <br /><br />
              If a Interviewrr class is canceled by the teacher for any other reason, students will have the option to either receive a full refund or transfer their enrollment to a future class. 
              <br /><br />
              If a student wishes to transfer their enrollment to a future class, they must inform us in writing via email, letter, or messenger (Whatsapp/Telegram) at least 14 days prior to the start of the original class. 
              <br /><br />
              If a student transfers their enrollment to a future class, they will not be eligible for a refund. All refund requests must be made in writing via email, letter, or messenger (Whatsapp/Telegram) and will be processed within 30 days of receipt. 
              Refunds will be made using the same method of payment that was used to make the original payment (e.g. credit card, PayPal). 
              <br /><br />
  
               
              </CContainer>
          </div>
       
        </CRow>
  
      
    </div>
  </div>
  </template>
  
      
  <script>
  import Vue from "vue";
  import { Carousel3d, Slide } from "vue-carousel-3d";
  
  Vue.use(require("vue-moment"));
  import VuejsDialog from "vuejs-dialog";
  import "vuejs-dialog/dist/vuejs-dialog.min.css";
  import Mainlayout from "../containers/AllHeader.vue";
  import Footerlayout from "../containers/TheFooter.vue";
  
  
  import AOS from "aos";
  import "aos/dist/aos.css";
  import backgroundUrl from "../assets/img/bgPurpleYellow.png";
  // Tell Vue to install the plugin.
  Vue.use(VuejsDialog);
  
  import _ from "lodash";

  
  export default {
    name: "Login",
    components: {
      Carousel3d,
      Slide,
      Mainlayout,
      Footerlayout
    },
    data() {
      return {
        backgroundUrl,
        
        TermInfo: true,
        isShowTerm: true,
  
        Notice: false,
        isShowNotice: false,
  
        Return: false,
        isShowReturn:  false,
      };
    },
    created() {
      AOS.init();
    },
    beforeMount() {
    },
     async mounted() {
    },
    methods: {
     
     
      navbarShow() {
        this.cardList = true;
      },
      GoToPagePro() {
        this.$router.push("/ProClass");
      },
      GotoLogin() {
        this.$router.push("https://Interviewrr.com/TuitionCenter/Login");
      },
      GotoApple() {
        this.$router.push("https://apps.apple.com/my/app/Interviewrr/id1366167288");
      },
      GotoGoogle() {
        this.$router.push(
          "https://play.google.com/store/apps/details?id=com.cellnet.Interviewrr"
        );
      },
  
      onAfterSlideChange(index) {
        console.log(
          "@onAfterSlideChange Callback Triggered",
          "Slide Index " + index
        );
      },
      onBeforeSlideChange(index) {
        console.log(
          "@onBeforeSlideChange Callback Triggered",
          "Slide Index " + index
        );
      },
      onLastSlide(index) {
        console.log("@onLastSlide Callback Triggered", "Slide Index " + index);
      },
      ShowTerm() {
        this.TermInfo = true;
        this.isShowTerm = true;
  
        this.Notice = false;
        this.isShowNotice = false;
  
        this.Return = false;
        this.isShowReturn = false;
  
      },
      ShowNotice() {
        this.TermInfo = false;
        this.isShowTerm = false;
  
        this.Notice = true;
        this.isShowNotice = true;
  
        this.Return = false;
        this.isShowReturn = false;
  
      },
  
      ShowReturn() {
        this.Return = true;
        this.TermInfo = false;
        this.isShowTerm = false;
  
        this.Notice = false;
        this.isShowNotice = false;
        this.Return = true;
        this.isShowReturn = true;
  
  
      },
    },
  };
  </script>
  <style>
  
  
  @import url("https://fonts.googleapis.com/css2?family=Rubik:wght@300&display=swap");
  </style>
  